import { PreparationOrder } from "@/model/preparation/PreparationOrder";
import { PreparationOrderStatus } from "@/model/preparation/PreparationOrderStatus";

// most advanced first - used to resolve a status mismatch between FAB/ASV siblings
// (should normally never happen, only if one of the two status updates failed to save)
const STATUS_RANK: Record<PreparationOrderStatus, number> = {
    [PreparationOrderStatus.CANCELED]: 5,
    [PreparationOrderStatus.DELIVERED]: 5,
    [PreparationOrderStatus.FAILED]: 4,
    [PreparationOrderStatus.PREPARED]: 3,
    [PreparationOrderStatus.PREPARING]: 2,
    [PreparationOrderStatus.TO_PREPARE]: 1
};

export class PreparationOrderHelper {

    static mergeByOrderNumber(orders: PreparationOrder[]): PreparationOrder[] {
        const groupedByOrderNumber = new Map<string, PreparationOrder[]>();

        orders.forEach(order => {
            const group = groupedByOrderNumber.get(order.orderNumber) ?? [];
            group.push(order);
            groupedByOrderNumber.set(order.orderNumber, group);
        });

        return Array.from(groupedByOrderNumber.values()).map(PreparationOrderHelper.mergeGroup);
    }

    private static mergeGroup(group: PreparationOrder[]): PreparationOrder {
        const [mergedOrder] = group;

        mergedOrder.products = group.flatMap(order =>
            order.products.map(product => {
                product.preparationType = order.preparationType;
                product.sourceOrderId = order.orderId;
                return product;
            })
        );

        mergedOrder.orderIds = group.map(order => order.orderId);
        mergedOrder.preparationType = null;
        mergedOrder.status = PreparationOrderHelper.mostAdvancedStatus(group);

        return mergedOrder;
    }

    private static mostAdvancedStatus(group: PreparationOrder[]): PreparationOrderStatus {
        return group
            .map(order => order.status)
            .reduce((mostAdvanced, status) => STATUS_RANK[status] > STATUS_RANK[mostAdvanced] ? status : mostAdvanced);
    }
}